import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Keys } from '@holmescorp/common';
import { createNlsMiddleware, keymap, pathmap } from '@holmescorp/lcc-state';
import css from '../css/topicgroup.m.css';
const nls = createNlsMiddleware('quiz');
const factory = create({ nls, theme }).properties();
export const ExerciseButton = factory(({ properties, middleware: { nls, theme } }) => {
    const themeCss = theme.classes(css);
    const { topicid, quizid, title } = properties();
    const which = quizid && quizid.split('-').pop();
    const genericText = nls().format('exerciseText', { which });
    const text = title ? title : genericText;
    return v('div', {
        classes: [themeCss.actionListItem],
        xqa: 'exercise-action-button',
        tabIndex: 0,
        onclick: (event) => {
            event && event.stopPropagation();
            const { path } = keymap.get(topicid);
            const { view } = pathmap.get(`${path}/exercise-${which}`);
            view();
        },
        onkeydown: (event) => {
            const { path } = keymap.get(topicid);
            const { view } = pathmap.get(`${path}/exercise-${which}`);
            switch (event.key) {
                case Keys.Enter:
                case Keys.Space:
                case Keys.Spacebar:
                    event.preventDefault();
                    view();
            }
        }
    }, [
        w('TopicStatusIcon', { key: quizid, useQuizScore: true, quizCompleteOnly: false }),
        v('div', { classes: [themeCss.actionText] }, [text])
    ]);
});
